<div class="row autopay-container">
  <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
    <confirmation
      [config]="confirmationConfig$ | async"
      (primaryEvent)="primaryButtonClick()"
      (tertiaryEvent)="teritaryButtonClick()"
    >
      @if ((hasError$ | async) === false) {
        <p class="margin-bottom-20">
          {{ deleteSuccessText | async }}
        </p>
      }
      @if (hasError$ | async) {
        <p class="margin-bottom-20">
          {{ deleteFailureText }}
        </p>
      }
    </confirmation>
  </div>
</div>
